module.exports = __webpack_public_path__ + "img/摄图网_500548327_banner_商务金融云购物（非企业商用）.d123cc28.png";